/**
 * Csv Schema of MascaraTransportadorSacPublico
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {MascaraTransportadorSacPublico} from '@/model/resource/MascaraTransportadorSacPublico'

/* TODO: review generated schema */
export class CsvMascaraTransportadorSacPublicoSchema extends Schema {
  readonly name = 'CsvMascaraTransportadorSacPublico'

  readonly fieldSet: FieldSet<MascaraTransportadorSacPublico> = {
    idMascaraTransportadorSacPublicoPk: schema =>
      schema.model.idMascaraTransportadorSacPublicoPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
